import { Button } from "@material-ui/core";
import React, { useCallback, useEffect } from "react";
import { pages, performancePages } from "../../../../constants/brandPerformanceConstants";
interface Props {
  setPerformancePage: React.Dispatch<React.SetStateAction<performancePages>>;
  activePage: performancePages;
  pagesWithData: string[];
}

const PerfNavButtons = (props: Props) => {
  const { setPerformancePage, activePage, pagesWithData } = props;

  const onBtnLinkClick = useCallback(
    (evt: React.MouseEvent<HTMLElement>) => {
      evt.stopPropagation();
      const {
        currentTarget: { dataset },
      } = evt;
      const pageLink = dataset?.page ?? "volume";

      setPerformancePage(pageLink as performancePages);
    },
    [history]
  );
  return (
    <div className="perf_nav_buttons primary_tile_background">
      {pages.map((page) => (
        <div key={page.pageId} className="nav_button">
          <Button
            variant={"outlined"}
            className={
              pagesWithData.includes(page.pageId)
                ? `filter_btn_element ${activePage == page.pageId ? "active" : ""}`
                : `filter_btn_element_data_not_available ${activePage == page.pageId ? "active" : ""}`
            }
            data-page={page.pageId}
            onClick={(evt) => onBtnLinkClick(evt)}
            size={"small"}
            data-test-id={page.pageId}
          >
            {page.pageName}
          </Button>
        </div>
      ))}
    </div>
  );
};

export default PerfNavButtons;
